// extracted by mini-css-extract-plugin
export var discard = "_6f-3";
export var muiTooltipTooltip = "_6f-5";
export var notificationBar = "_6f-2";
export var saveButtonHoverSlotWrapper = "_6f-4";
export var show = "_6f-1";
export var spacer = "_6f-0";